module.exports = __webpack_public_path__ + "static/media/man-1.634b98f5.jpg";